// export const WEBSITE_URL = "https://admin.pedecome.pt";
export const IMAGES_URL = "https://images.pedecome.pt";
export const WEBSITE_URL = "https://admin.pedecome.pt";
// export const WEBSITE_URL = "https://mywebsite.com";

